module.exports = __webpack_public_path__ + "static/media/hero.869dd766.png";